export class Position {
    constructor(sizeX: number, sizeY: number, col: number, row: number) {
        this.sizeX = sizeX;
        this.sizeY = sizeY;
        this.col = col;
        this.row = row;
    }

    sizeX: number;
    sizeY: number;
    col?: number;
    row?: number;
}